import { useEffect, useState } from "react";
import useApi from "../../../../../hooks/use-api";
import { Controller, useForm } from "react-hook-form";
import styles from '../../../../../styles/transitionplan.module.css';
import { Button, Col, Row, Spinner } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faSave } from "@fortawesome/free-solid-svg-icons";
import {NumericFormat} from 'react-number-format';
import { EmptyStringToNull, NullableInputToEmptyString } from "../../../../../utilities/rhfdatanormalizationfunctions";
import * as Yup from 'yup';
import { yupResolver } from "@hookform/resolvers/yup";
import FormInputValidationMessage from "../../../../../components/forminputvalidationmessage";

const ProviderAddEdit = ({ApplicationID,NeedID,GoalID,ServiceID,ProviderID,ReturnFunction,RefreshFunction}) => {
    const [isLoading,SetisLoading] = useState(true);
    const [providerTypes,setProviderTypes] = useState([]);
    const [fundingTypes,setFundingTypes] = useState([]);
    const [feedback, setFeedback] = useState(null);

    const initialValues = {
        Name: '',
        ProviderType: '',
        ProviderTypeOther: '',
        FundingType: '',
        RequestedAmount: '',
        Address: '',
        City: '',
        State: '',
        Zip: '',
        Phone: '',
        Comments: ''
    }

    const validationSchema = Yup.object().shape({
        FundingType: Yup.string().required('*Type is Required')
    });

    const {control,register,handleSubmit,reset,watch,formState: {errors,isDirty,isSubmitting}} = useForm({defaultValues: initialValues,resolver: yupResolver(validationSchema)});

    const {getRequest,postRequest,putRequest} = useApi();

    const prepareDataForSend = (data) => {
        const transformedObj = {};
        for (const key in data) {
            if (data.hasOwnProperty(key)) {
                transformedObj[key] = EmptyStringToNull(data[key]);
            }
        }
        return transformedObj;
        
    }

    const _onSubmit = async(items) => {
        setFeedback(null);
        const sendData = prepareDataForSend(items);

        if(ProviderID){
            const [data,status] = await putRequest('UpdateProvider',{...sendData,ApplicationID : ApplicationID,NeedID: NeedID, GoalID: GoalID, ServiceID: ServiceID, ProviderID: ProviderID});

            if(status === 200){
                setFeedback({ type: "success", message: "The Provider was successfully updated." });

                const{id,...Values} = data;

                const formVals = _NormalizeForm(Values);

                reset({
                    Name: formVals.name,
                    ProviderType: formVals.providertypeid,
                    ProviderTypeOther: formVals.providertypeother,
                    FundingType: formVals.fundingtypeid,
                    RequestedAmount: formVals.homemodsupplementrequestamount,
                    Address: formVals.address,
                    City: formVals.city,
                    State: formVals.state,
                    Zip: formVals.zip,
                    Phone: formVals.phone,
                    Comments: formVals.comments
                });
                RefreshFunction({ preserveEditorViewport: true });
                
            }
            else{
                setFeedback({ type: "error", message: "An error occurred when updating the Provider." });
            }
        }
        else{
            const [data,status] = await postRequest('AddProvider',{...sendData,ApplicationID: ApplicationID, NeedID: NeedID, GoalID: GoalID, ServiceID: ServiceID});

            if(status === 201){
                setFeedback({ type: "success", message: "The Provider was successfully added." });
        
                RefreshFunction({ preserveEditorViewport: true });
                reset(initialValues);
            }
            else{
                setFeedback({ type: "error", message: "An error occurred when adding the Provider." });
            }
        }
    }
    const _NormalizeForm = (rawData) => {
    
            const resetData = Object.fromEntries(
                Object.entries(rawData).map(([key,value]) => [key,NullableInputToEmptyString(value)])
            );
    
            const resetValues = resetData;
    
            return resetValues;
    }

    const get = async () => {
        SetisLoading(true);
        const [typesData,providerData] = await Promise.all([
            getRequest('ProviderTypes'),
            getRequest('Provider',{ApplicationID : ApplicationID,NeedID : NeedID,GoalID: GoalID,ServiceID: ServiceID,ProviderID: ProviderID})
        ]);

        SetisLoading(false);

        const [extractedTypeData,typeStatus] = typesData;
        const [extractedProviderData,providerStatus] = providerData;

        if(typeStatus === 200 && providerStatus === 200){
            setProviderTypes(extractedTypeData.providertypes);
            setFundingTypes(extractedTypeData.fundingtypes);

            const{id,...dataValues} = extractedProviderData;

            const normalizedForm = _NormalizeForm(dataValues);

            reset({
                Name: normalizedForm.name,
                ProviderType: normalizedForm.providertypeid,
                ProviderTypeOther: normalizedForm.providertypeother,
                FundingType: normalizedForm.fundingtypeid,
                RequestedAmount: normalizedForm.homemodsupplementrequestamount,
                Address: normalizedForm.address,
                City: normalizedForm.city,
                State: normalizedForm.state,
                Zip: normalizedForm.zip,
                Phone: normalizedForm.phone,
                Comments: normalizedForm.comments
            });
        }
        else{
            setProviderTypes([]);
            setFundingTypes([]);
        }
    }

    const getTypes =  async() => {
        SetisLoading(true);
        const [data,status] = await getRequest('ProviderTypes',{timestamp: Date.now()});
        SetisLoading(false);

        if(status === 200){
            setProviderTypes(data.providertypes)
            setFundingTypes(data.fundingtypes);
        }
        else{
            //Handle error
            setProviderTypes([]);
            setFundingTypes([]);
        }
    }

    useEffect(() => {
        if(ProviderID){
            get();
        }
        else{
            getTypes();
        }
    },[ServiceID])

    if(isLoading){
        return(
            <div className={styles.statusMessage} role="status" aria-live="polite">Loading provider form...</div>
        )
    }
    
    const providertype = watch('ProviderType');

    const showotherfield = providertype !== '' && providerTypes.find(item => item.id === providertype)
    ?
        providerTypes.find(item => item.id === providertype).hasfollowup
    :
        false


    return(
        <form onSubmit={handleSubmit(_onSubmit)}>
            <div className={`clientCard ${styles.editorEmbeddedCard}`}>
                <div className={`${styles.needBody} ${styles.editorEmbeddedBody}`}>
                    <Row>
                        <Col xs={12}>
                        <label htmlFor="name">Name</label>
                        <input type="text" id="name" {...register('Name')} style={{width: '100%'}}/>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12}>
                            <label htmlFor="type">Provider Type</label>
                            <select id="type" {...register('ProviderType')} style={{width: '100%',height: '32px'}}>
                                <option value=''>--Provider Type--</option>
                                {
                                    providerTypes.map((type) => (
                                        <option key={type.id} value={type.id}>{type.name}</option>
                                    ))
                                }
                            </select>
                        </Col>
                        {
                            showotherfield &&
                            <Col xs={12}>
                                <label htmlFor="typeother">Provider Type (Other)</label>
                                <input type="text" id="typeother" {...register('ProviderTypeOther')} style={{width: '100%',height: '32px'}} />
                            </Col>
                        }
                    </Row>
                    <Row>
                        <Col xs={12} md={6} lg={7}>
                            <label htmlFor="fundingtype">Funding Type</label>
                            <select id="fundingtype" {...register('FundingType')} style={{width: '100%', height: '32px'}} aria-invalid={errors.FundingType ? "true" : "false"}>
                                <option value=''>--Funding Type--</option>
                                {
                                    fundingTypes.map((type) => (
                                        <option key={type.id} value={type.id}>{type.name}</option>
                                    ))
                                }
                            </select>
                            <FormInputValidationMessage error={errors.FundingType} />
                        </Col>
                        <Col xs={12} md={6} lg={5}>
                        <label htmlFor="reqamount">Requested Amount</label>
                        <Controller 
                            name="RequestedAmount"
                            control={control}
                            // rules={{
                            //     validate: (values) => {
                            //         if(values !== undefined && values !== null){
                            //             if (values < 0.01)
                            //                 return "*Amount is required."
                            //             return true;
                            //         }
                            //         else{
                            //             return "*Amount is required."
                            //         }
                            //     }
                            // }}
                            render={({field}) => (
                                <NumericFormat 
                                    value={field.value ?? ''} 
                                    id="reqamount" 
                                    placeholder="Amount" 
                                    style={{width: '100%', height: '32px'}} 
                                    prefix={'$'} 
                                    decimalScale={2} 
                                    fixedDecimalScale={true} 
                                    allowNegative={false} 
                                    onValueChange={(values) => {
                                        if(values.floatValue === undefined || values.floatValue === null){
                                            field.onChange('');
                                        }
                                        else{
                                            field.onChange(values.floatValue);
                                        }
                                    }} 
                                />
                            )}
                        />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12}>
                        <label htmlFor="comments">Comments</label>
                        <textarea rows={4} id="comments" {...register('Comments')} style={{width: '100%'}} />
                        </Col>
                    </Row>
                    <fieldset className={styles.embeddedFieldset}>
                        <legend className={styles.embeddedLegend}>Provider Information</legend>
                        <div className={styles.addressBox}>
                            <div className={styles.addressBoxInner}>
                                <Row>
                                    <Col xs={12} md={8}>
                                        <label htmlFor="address">Address</label>
                                        <input type="text" id="address" {...register("Address")} style={{width: '100%'}} />
                                    </Col>
                                    <Col xs={12} md={4}>
                                        <label htmlFor="phone">Phone</label>
                                        <input type="text" id="phone" {...register("Phone")} style={{width: '100%'}} />
                                    </Col>
                                </Row>
                                <Row className="mb-1">
                                    <Col xs={12} lg={4} md={6}>
                                        <label htmlFor="city">City</label>
                                        <input type="text" id="city" {...register("City")} style={{width: '100%'}} />
                                    </Col>
                                    <Col xs={12} lg={4} md={6}>
                                        <label htmlFor="state">State</label>
                                        <input type="text" id="state" {...register("State")} style={{width: '100%'}} />
                                    </Col>
                                    <Col xs={6} md={4}>
                                        <label htmlFor="zip">Zip</label>
                                        <input type="text" {...register('Zip')} id="zip" style={{width: '100%'}}/>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </fieldset>
                    {feedback && (
                        <div className={`${styles.inlineFeedback} ${feedback.type === "error" ? styles.inlineFeedbackError : styles.inlineFeedbackSuccess}`} role="status" aria-live="polite">
                            {feedback.message}
                        </div>
                    )}
                    <div className="d-flex justify-content-end">
                        <Button type="submit" variant={ProviderID !== null ? 'primary' : 'success'} disabled={isLoading || !isDirty || isSubmitting}>
                            {
                                isSubmitting
                                ?
                                    <Spinner animation='border' size='sm' aria-hidden="true" />
                                :
                                    ProviderID
                                    ?
                                        <>
                                            <FontAwesomeIcon icon={faSave} size="xl" className="me-1" />
                                            Save
                                        </>
                                    :
                                        <>
                                            <FontAwesomeIcon icon={faPlus} size="xl" className="me-1" />
                                            Add Provider
                                        </>
                            }
                        </Button>
                    </div>
                </div>
            </div>
        </form>
    )
}

export default ProviderAddEdit;
